/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrderedFileDtoFromJSON, OrderedFileDtoToJSON, } from './';
export function OrderedFileDtoGenericApiResponseFromJSON(json) {
    return OrderedFileDtoGenericApiResponseFromJSONTyped(json, false);
}
export function OrderedFileDtoGenericApiResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'content': !exists(json, 'content') ? undefined : OrderedFileDtoFromJSON(json['content']),
        'errors': !exists(json, 'errors') ? undefined : json['errors'],
    };
}
export function OrderedFileDtoGenericApiResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'content': OrderedFileDtoToJSON(value.content),
        'errors': value.errors,
    };
}
